import { render, staticRenderFns } from "./RentalObjectNewTenancyForm.vue?vue&type=template&id=3b03dede&scoped=true&"
import script from "./RentalObjectNewTenancyForm.vue?vue&type=script&lang=js&"
export * from "./RentalObjectNewTenancyForm.vue?vue&type=script&lang=js&"
import style0 from "./RentalObjectNewTenancyForm.vue?vue&type=style&index=0&id=3b03dede&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b03dede",
  null
  
)

export default component.exports